import React from 'react';

const About = () => {
    return (
        <div>
            <h1>About Page</h1>
            <p>This is an example of a persistent audio player in React.</p>
        </div>
    );
};

export default About;
